import { V1User } from './user';

type Workspace = Omit<V1User, 'is_staff' | 'is_team'> & {
  is_staff?: false;
  is_team: true;
};

declare global {
  namespace BB {
    type V1Workspace = Workspace;
  }
}

export type V1Workspace = Workspace;
